module.exports = __webpack_public_path__ + "img/ExpiredCouponMark.100c7b09.png";